// app/providers.tsx
"use client";
import React from "react";
import { ToastProvider } from "@/components/ui/Toast";
import { SupabaseProvider } from "@/lib/supabase/SupabaseProvider";

export default function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SupabaseProvider>
      <ToastProvider>
        {children}
      </ToastProvider>
    </SupabaseProvider>
  );
}
